import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


const initialState = {
  status: null,
  data: [],
};

export const getAssetsFamilies = createAsyncThunk(
  "getAssetsFamilies",
  async (data) => {
    try {
      const response = await fetch(`/api/assetsFamilies/${data.configid}/${data.locale}`, {
        method: "GET",
        cache: "no-store",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch assets familes");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const credentialsSlice = createSlice({
  name: "getAssetsFamilies",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAssetsFamilies.pending, (state) => {
        state.status = "PIM loading";
        state.message = null;
      })
      .addCase(getAssetsFamilies.fulfilled, (state, action) => {
        state.status = "PIM loaded";
        state.data = action.payload.data.data;
      })
      .addCase(getAssetsFamilies.rejected, (state, action) => {
        state.status = "error";
        state.message = action.error.message;
      });
  },
});

export default credentialsSlice.reducer;
